export const ACTION_RESET = 'FETCH_ANNOUNCERMENT_RESET';
export const ACTION_REQUEST = 'FETCH_ANNOUNCERMENT_REQUEST';
export const ACTION_SUCCESS = 'FETCH_ANNOUNCERMENT_SUCCESS';
export const ACTION_ERROR = 'FETCH_ANNOUNCERMENT_ERROR';
